import { Controller } from "@hotwired/stimulus";
import Sortable from "sortablejs";

// SCH-355 — drag-to-reorder automation steps. On drop, PATCH the full ordered
// list of step ids to reorder_steps. The server renumbers the working copy
// (forking a draft when the automation is running). If it forked a fresh draft,
// the response asks us to reload so the DOM picks up the draft's step ids and
// the "unpublished changes" banner.
export default class extends Controller {
  static values = { url: String };

  connect() {
    this.sortable = Sortable.create(this.element, {
      animation: 150,
      handle: "[data-reorder-handle]",
      ghostClass: "opacity-40",
      onEnd: () => this.persist(),
    });
  }

  disconnect() {
    this.sortable?.destroy();
  }

  async persist() {
    const ids = Array.from(this.element.querySelectorAll("[data-step-id]")).map(
      (el) => el.dataset.stepId,
    );
    const token = document.querySelector('meta[name="csrf-token"]')?.content;

    try {
      const res = await fetch(this.urlValue, {
        method: "PATCH",
        headers: {
          "X-CSRF-Token": token,
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify({ step_ids: ids }),
      });
      if (!res.ok) throw new Error("reorder failed");
      const data = await res.json().catch(() => ({}));
      if (data.reload) this.reload();
    } catch (e) {
      this.reload(); // resync the DOM with server truth on any failure
    }
  }

  reload() {
    if (window.Turbo) {
      window.Turbo.visit(window.location.href, { action: "replace" });
    } else {
      window.location.reload();
    }
  }
}
